import React from 'react';
import { ShieldCheckIcon, InfoIcon } from 'lucide-react';
export function CertificationFees() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2985">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2986">
        <div className="mb-12" data-id="element-2987">
          <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2988">
            <div className="p-4 border-b flex items-center gap-3" style={{
            backgroundColor: '#1e3d2f',
            borderColor: '#ede9e0'
          }} data-id="element-2989">
              <ShieldCheckIcon size={20} style={{
              color: '#c8a84b'
            }} data-id="element-2990" />
              <h3 className="text-base font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#ffffff'
            }} data-id="element-2991">
                NRA Certification Fee (Upon Passing)
              </h3>
            </div>
            <div className="overflow-x-auto" data-id="element-2992">
              <table className="w-full text-left border-collapse" data-id="element-2993">
                <thead data-id="element-2994">
                  <tr style={{
                  backgroundColor: 'rgba(30,61,47,0.04)'
                }} data-id="element-2995">
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#1e3d2f',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-2996">
                      Membership
                    </th>
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#1e3d2f',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-2997">
                      Fee (2-Year Term)
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-2998">
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-2999">
                    <td className="p-4 font-medium text-gray-800" data-id="element-3000">
                      NRA Members
                    </td>
                    <td className="p-4 font-bold text-[#1e3d2f]" data-id="element-3001">$35</td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-3002">
                    <td className="p-4 font-medium text-gray-800" data-id="element-3003">
                      Non-NRA Members
                    </td>
                    <td className="p-4 font-bold text-[#1e3d2f]" data-id="element-3004">$60</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bg-[#f0f7f3] p-4 border-t border-[#ede9e0] flex items-start gap-3" data-id="element-3005">
              <InfoIcon size={20} style={{
              color: '#2d5a3d'
            }} className="flex-shrink-0 mt-0.5" data-id="element-3006" />
              <p className="text-sm font-medium" style={{
              color: '#1e3d2f'
            }} data-id="element-3007">
                <strong data-id="element-3008">Note for currently certified instructors:</strong>{' '}
                Certification fees are $15 for NRA members and $30 for non-NRA
                members.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}